import React from "react";
import { setSetting } from "../../../utils/frontendSettingsManager";
import { StyledHideSomeInfo } from "./styledHideSomeInfo";
import MaterialSwitch from "../../styles/materialSwitch";

const HideSomeInfo = ({ data, setData, name, label }) => {
  const handleChangeSetting = (event) => {
    let value = event.target.checked;

    setSetting(name, value);
    setData(value);
  };

  return (
    <StyledHideSomeInfo>
      <div>
        {label ?? "Hide some info"}
      </div>
      <MaterialSwitch
        checked={data}
        onChange={handleChangeSetting}
        name={label ?? "Hide some info"}
      />
    </StyledHideSomeInfo>
  );
};

export default HideSomeInfo;